module.exports = __webpack_public_path__ + "static/media/institute-7-min.c6043dd9.webp";